const WEEKS: { week: string; title: string; detail: string }[] = [
  { week: "1주", title: "문자와 첫인사", detail: "히라가나·가타카나 46자와 기본 인사" },
  { week: "2주", title: "물건·일정 확인", detail: "명사·숫자로 물건·요일·시간 확인" },
  { week: "3주", title: "가격·상태 표현", detail: "형용사·숫자로 가격·시간·느낌 표현" },
  { week: "4주", title: "장소·물건 찾기", detail: "존재·위치 표현으로 시설·물건 찾기" },
  { week: "5주", title: "희망·계획 말하기", detail: "동사 활용, 먹고 싶은 것·가고 싶은 곳" },
  { week: "6주", title: "부탁·허락 표현", detail: "여행 중 부탁과 허가·금지 표현" },
  { week: "7주", title: "경험·일정 말하기", detail: "경험·가능·계획 표현으로 대화 잇기" },
  { week: "8주", title: "정보·인상 나누기", detail: "전언·추측·수수 표현으로 자연스러운 대화" },
];

export default function Curriculum() {
  return (
    <section id="curriculum" className="py-10 md:py-28 bg-secondary-50">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        <div className="text-center mb-14">
          <span className="text-[10px] md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            8 Weeks Curriculum
          </span>
          <h2 className="mt-3 font-heading text-xl md:text-4xl font-bold text-foreground-950">
            8주 커리큘럼
          </h2>
          <p className="mt-2 text-xs sm:text-base text-foreground-700">
            기초 문법을 차근차근 배우고, 매주 여행에서 사용할 수 있는 표현으로 연결합니다.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-6 left-0 right-0 h-0.5 bg-background-300"></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-8 gap-3">
            {WEEKS.map((w, idx) => (
              <div key={w.week} className="relative flex flex-col items-center text-center">
                <div
                  className={`relative z-10 w-9 h-9 sm:w-12 sm:h-12 flex items-center justify-center rounded-full font-heading font-bold text-xs sm:text-sm border-2 ${
                    idx === 0
                      ? "bg-primary-500 text-background-50 border-primary-500"
                      : idx === WEEKS.length - 1
                      ? "bg-accent-500 text-background-50 border-accent-500"
                      : "bg-background-50 text-primary-600 border-primary-300"
                  }`}
                >
                  {w.week}
                </div>
                <div className="mt-4 bg-background-50 border border-background-200 rounded-lg px-3 py-2 sm:py-3 w-full min-h-[90px] sm:min-h-[120px] hover:border-primary-300 transition-colors">
                  <h4 className="font-heading font-bold text-[11px] sm:text-xs text-foreground-950 leading-snug break-all">
                    <a href={`#week-${idx + 1}`} onClick={(e) => e.preventDefault()}>
                      {w.title}
                    </a>
                  </h4>
                  <p className="mt-2 text-[10px] sm:text-[11px] text-foreground-600 leading-relaxed break-all">
                    {w.detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}